// noinspection NonAsciiCharacters
const isoMapping: Record<string, string> = {
    ß: 'ss',
    æ: 'ae',
    ø: 'o',
    œ: 'oe',
    þ: 'th',
    ð: 'd',
    Æ: 'AE',
    Ø: 'O',
    Œ: 'OE',
    Þ: 'TH',
    Ð: 'D',
}

export const toStrictISOString = (str: string): string => str
    // 1. Manual mapping for atomic characters
    .replace(/[ßæøœþðÆØŒÞÐ]/g, m => isoMapping[m] || m)
    // 2. Decompose accents
    .normalize('NFD')
    // 3. Remove all non-ASCII characters (this kills diacritics AND symbols)
    // eslint-disable-next-line no-control-regex
    .replace(/[^\x09-\x0D\x20-\x7E]/g, '')
